import {
  CTypeMainHead,
  ATypeCardView,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  colors,
  CTypeMap,
  ATypeBeneficiaryCTA,
  BTypeBreadCrumb,
  FullWidthButton,
  GOI_WEB_URL,
} from "goi_common";
import { GetStaticPaths, GetStaticProps } from "next";

import React from "react";
import { ParlorDetailProps } from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";
import facilities from "goi_common/src/constants/facilities_detail.json";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = facilities
    .filter((f) => targetSidos.includes(f.sido) && f.is_public)
    .map((f) => ({
      params: {
        companyname: f.companyname + " 기초생활수급자 안내",
      },
    }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const code = params?.companyname as string;
  const companyname = code.replace(" 기초생활수급자 안내", "");
  let p_facility;
  let district;
  let name = "";
  let description = "";

  if (companyname) {
    p_facility = facilities.find((f) => f.companyname === companyname);
    if (p_facility) {
      name = p_facility.companyname;

      district = p_facility.address.slice(0, 2);
      if (p_facility.address.split(" ")[0].length == 4)
        district = p_facility.address[0] + p_facility.address[2];

      description = `${p_facility.companyname} 기초생활수급자는 화장 비용 어떻게 될까? ${p_facility.address}`;
    }
  }

  return {
    props: {
      defaultPFacility: p_facility,
      pageDescription: description,
      pageKeywords: `${p_facility?.companyname}, ${p_facility?.companyname} 기초생활수급자, ${district} 기초생활수급자 장례, 장제비, 장제급여, 기초생활수급자 장례 얼마,`,
      pageOgTitle: `기초생활 보호 대상자를 위한 화장 비용 안내 (${p_facility?.companyname})::  대전충청장례정보포털`,
      pageOgDescription: description,
      pageOgImage: p_facility?.images[0].url || "",
      hasError: !p_facility,
    },
  };
};

export default function companyname({
  defaultPFacility,
  pageOgTitle,
}: {
  defaultPFacility: ParlorDetailProps;
  pageOgTitle: string;
}) {
  const regionPFacilities = facilities.filter((p) =>
    targetSidos.includes(String(p.sido)) && p.is_public
  );
  const sidoName = FUNERAL_SIDO.get(Number(defaultPFacility.sido));
  const sigunguName = FUNERAL_SIGUNGU.get(Number(defaultPFacility.sido))?.get(
    Number(defaultPFacility.sigungu)
  );
  const carouselItems = regionPFacilities.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.ch-funeralportal.co.kr/benefit-support/free-facility/${res.companyname} 기초생활수급자 안내`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionPFacilities.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <Stack>
      <Head>
        <title>{pageOgTitle}</title>
        {regionPFacilities.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>
      <BTypeBreadCrumb
        firstItem={{
          text: `기초수급자장례 추천`,
          href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
          event: {
            domain: "ch",
            path: "benef_sup_fr_fac",
            trigger_and_target: "br_crumb_mth_req",
          },
        }}
        secondItem={{
          text: `기초생활수급자 장례114`,
          href: `/benefit-support/`,
          event: {
            domain: "ch",
            path: "benef_sup_fr_fac",
            trigger_and_target: "br_crumb_benef_sup",
          },
        }}
        goiHomeEvent={{
          domain: "ch",
          path: "benef_sup_fr_fac",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />
      <CTypeMainHead
        sidoName={sidoName}
        sigunguName={sigunguName}
        mainColor={regionColor}
        defaultParlor={defaultPFacility}
        title={`${defaultPFacility.companyname}`}
        managed_type={defaultPFacility.managed_type}
        isJangji
        event={{
          domain: "ch",
          path: "benef_sup_fr_facility",
          trigger_and_target: "uv_mth_req",
        }}
      />

      <Stack padding="24px 16px 10px" gap="12px">
        <Stack padding="0px 20px 0px" gap="4px">
          <Box className="subtitle_18_b">필요 서류</Box>
          <Stack
            className="body_16_m"
            style={{
              background: colors.gray50,
              padding: "12px 14px",
              margin: "10px 0",
            }}
          >
            기초생활수급자는 화장 비용이 전액 감면됩니다.
          </Stack>
          <Stack gap="12px">
            <Box className="body_14_m" component="p">
              화장 비용을 전액 감면 받기 위해 기초생활수급자 자격을 증명하는
              서류가 필요합니다.
            </Box>
            <Box className="subtitle_14_b" component="p">
              필요 서류 : 국민기초생활보장수급자 증명서
            </Box>
            <Box className="body_14_m" component="p">
              수급자 증명서는 전국 시군구 또는 읍면동 주민센터에서 발급
              가능하며, 무인민원발급기(본인에 한함)와 정부24 웹사이트에서 또한
              발급 가능합니다.
            </Box>
            <Box className="body_14_m" component="p">
              기초생활수급자분들은 상기한 2가지 혜택을 받을 수 있습니다.{" "}
              <b className="subtitle_14_b">
                이해하기 어려운 부분이나 추가 정보가 필요하시다면, 언제든지
                상담을 신청해 주세요.
              </b>
            </Box>
          </Stack>
        </Stack>
        <Stack padding="20px 0">
          <FullWidthButton
            text="바로 상담하기"
            href="tel:1666-9784"
            backgroundColor={regionColor.c400}
            event={{
              domain: "ch",
              path: "benef_sup_fr_facility",
              trigger_and_target: "goi_call",
            }}
          />
        </Stack>
      </Stack>

      <Stack padding="24px 16px 10px" gap="12px">
        <ATypeBeneficiaryCTA
          mainColor={regionColor}
          event={{
            domain: "ch",
            path: "benef_sup_fr_facility",
            trigger_and_target: "goi_call_btom",
          }}
        />
      </Stack>

      <Stack padding="24px 16px 20px" gap="12px">
        <CTypeMap
          defaultParlor={defaultPFacility}
          address={defaultPFacility.address}
        />
      </Stack>

      <Stack padding="24px 16px 10px" gap="12px">
        <h3 className="subtitle_18_b">충청 대전 세종 기초생활수급자 장지</h3>
        {regionPFacilities.map((res) => (
          <ATypeCardView
            key={res.companyname}
            name={res.companyname}
            href={`/benefit-support/free-facility/${res.companyname} 기초생활수급자 안내/`}
            // descriptions={["기초생활수급자 무료"]}
            descriptions={[""]}
            imgSrc={res.images[0]?.url ? res.images[0].url : ""}
            event={{
              domain: "ch",
              path: "benef_sup_fr_facility",
              trigger_and_target: "uv_facility",
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
}
